import { DepartureOrArrival } from '@shared/models/departureOrArrival';
import { timeToClockFormat } from '@shared/utils/time';

export function getHasChangedTargetClockTime(
  departureOrArrival: DepartureOrArrival,
): boolean {
  if (departureOrArrival.isCancelled) {
    return true;
  }
  if (departureOrArrival.targetTime === undefined) {
    return false;
  }

  const clockTargetTime = timeToClockFormat(departureOrArrival.targetTime);
  const clockTime = timeToClockFormat(departureOrArrival.time);

  return clockTargetTime !== clockTime;
}
